<template>
  <v-container fluid class="container-calendar">
    <div class="desktop">
      <h1 class="text-center mb-n2" v-if="startDateToFilter !== null && !isEmbedded">
        <v-icon class="arrow mt-n1" @click="prevMonth" small>fa-chevron-left</v-icon>
        {{ monthNames[startDateToFilter.getMonth()] }} {{ startDateToFilter.getFullYear() }}
        <v-icon class="arrow mt-n1" @click="nextMonth" small>fa-chevron-right</v-icon>
      </h1>
      <v-row v-if="!isEmbedded" align="center" justify="center">
        <v-col class="summary d-flex justify-center" cols="5">
          <p class="mt-3 mr-3">{{ $t('summaryPrepend') }}</p>
          <v-select class="select-account" v-model="accountSelected" :items="brokerAccounts" item-value="id"
            @change="retrieveMonthTrades" dense outlined>
            <template v-slot:selection="data">
              {{ (data.item.broker.name !== 'All') ? ((data.item.identifier !== '') ? data.item.identifier :
                data.item.broker.name) : 'All' }}
              <img v-if="data.item.verified" src="@/assets/icons/Audited.svg" alt="Audited Icon" class="ml-2" style="width: 16px; height: 16px;" />
            </template>
            <template v-slot:item="data">
              {{ (data.item.identifier !== '') ? `${data.item.broker.name} · ${data.item.identifier}` :
                data.item.broker.name
              }}
             <img v-if="data.item.verified" src="@/assets/icons/Audited.svg" alt="Audited Icon" class="ml-2" style="width: 16px; height: 16px;" />
            </template>
          </v-select>
          <p class="mt-3 ml-3" v-if="accountSelected === $t('All')">{{ $tc('summaryAppend', (accountSelected === $t('All')) ? 2 : 1) }}</p>
        </v-col>
      </v-row>
      <v-row v-if="isEmbedded" align="center" justify="center" class="mt-n7 mb-3">
        <p class="mt-3 ml-3" style="color:#3b3b3b;">{{ $t('poweredBy_CalendarIndex') }}</p>
        <v-img class="ml-3 mt-0" src="https://hub.swiset.com/wp-content/uploads/2020/05/Swiset_Imagotipo_RGB_Black.svg"
          max-width="140px" contain />
      </v-row>
      <v-calendar :start="startCalendar" :end="endCalendar" ref="calendar" :now="today" :value="today" color="primary"
        style="min-height: 75vh" type="month" v-model="focus" @change="calendarChanged">
        <template v-slot:day="{ past, date }">
          <template v-if="past && tradingDays[date] !== undefined">
            <v-card @mouseenter="setHoverDay(date)" @mouseleave="removeHoverDay" class="px-3 py-5"
              :style="(tradingDaysData[2][tradingDays[date]] > 0) ? 'background-color: #00F784' : 'background-color: #ff7a7a'"
              outlined>
              <h2 v-if="validateShowMore(date)" style="color: #111111">{{ getProfitFactor(date) }} <span>{{
                $t('profitFactor') }}</span></h2>
              <h2 v-if="validateShowMore(date)" style="color: #111111">{{
                tradingDaysData[3][tradingDays[date]].toFixed(2)
              }} <span>{{ $t('bestProfit') }}</span></h2>
              <h2 v-if="tradingDaysData[2][tradingDays[date]] > 0" style="color: #111111">+{{
                tradingDaysData[2][tradingDays[date]].toFixed(2) }} <span>{{ $t('netProfit_CalendarIndex') }}</span></h2>
              <h2 v-else style="color: #111111">{{ tradingDaysData[2][tradingDays[date]].toFixed(2) }} <span>{{
                $t('netProfit_CalendarIndex') }}</span></h2>
              <!-- h2 style="color: #FFFFFF">{{ (tradingDaysData[1][tradingDays[date]] * 100 / tradingDaysData[0][tradingDays[date]]).toFixed(2) }}% <span>Win Rate</span></h2 !-->
              <p class="mb-0" style="color: #111111; font-size: 16px;">{{ tradingDaysData[0][tradingDays[date]] }}
                trades
              </p>
            </v-card>
          </template>
        </template>
      </v-calendar>
    </div>

    <div class="mobile">
      <h3 class="text-center my-16">
                <v-icon class="d-flex align-center justify-center mt-12 mb-5" x-large>fa-regular fa-grin-beam-sweat</v-icon>
                {{ $t('messageMobile') }}
            </h3>
    </div>
  </v-container>
</template>

<script>
import Repository from '../../repositories/journal';

export default {
  name: "CalendarIndex",
  components: {},
  data() {
    return {
      focus: '',
      today: '2019-01-08',
      selectedEvent: {},
      selectedElement: null,
      startDateToFilter: null,
      endDateToFilter: null,
      selectedOpen: false,
      hoverDate: '',
      monthTrades: [],
      monthNames: [],
      tradingDays: {},
      tradingDaysData: [
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Number of trades
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Number of positive trades
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Net profit
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Best profit
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Negative Sum
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Positive Sum
      ],
      brokerAccounts: [{ broker: { name: this.$t('All') }, identifier: '', id: this.$t('All') }],
      accountSelected: '',
    };
  },
  watch: {
    '$i18n.locale': function () {
      this.getMonths();
    },
  },
  mounted() {
    this.getMonths();
    this.init();
  },
  computed: {
    isEmbedded() {
      return this.$store.state.whitelabel.partner !== null;
    },
    startCalendar() {
      return this.$route.query.startDate
    },
    endCalendar() {
      return this.$route.query.endDate
    }
  },
  methods: {
    getMonths() {
      this.monthNames = [
        this.$t('months.jan'),
        this.$t('months.feb'),
        this.$t('months.mar'),
        this.$t('months.apr'),
        this.$t('months.may'),
        this.$t('months.jun'),
        this.$t('months.jul'),
        this.$t('months.aug'),
        this.$t('months.sep'),
        this.$t('months.oct'),
        this.$t('months.nov'),
        this.$t('months.dec'),
      ];
    },
    init() {
      this.today = this.getToday();
      this.$refs.calendar.checkChange();
      this.$store.state.user.brokerAccounts.forEach((brokerAccount) => {
        this.brokerAccounts.push(brokerAccount);
      });
      this.accountSelected = this.$t('All');
      this.retrieveMonthTrades();
    },
    getToday() {
      this.focus = '';
      let today = new Date();
      this.startDateToFilter = new Date(today.getFullYear(), today.getMonth());
      this.endDateToFilter = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      return `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()} ${today.getHours()}:${today.getMinutes()}`;
    },
    prevMonth() {
      this.$refs.calendar.prev();
    },
    nextMonth() {
      this.$refs.calendar.next();
    },
    async calendarChanged({ start, end }) {
      await this.refreshDates(start, end);
      await this.retrieveMonthTrades();
    },
    async refreshDates(start, end) {
      this.$refs.calendar.checkChange();
      this.startDateToFilter = new Date(`${start.date}T00:00:00`);
      this.endDateToFilter = new Date(`${end.date}T23:59:59`);
    },
    retrieveMonthTrades() {
      /* eslint-disable no-console */
      let filter = {
        userId: this.$store.state.user.id,
        fromDate: this.startDateToFilter,
        toDate: this.endDateToFilter,
        side: 'All',
        mood: 'All',
        asset: 'All',
        brokerAccount: this.accountSelected,
        result: 'All',
        strategy: 'All',
      };

      this.monthTrades = [];
      Repository.filteredTradesOfUserGet(filter).then((response) => {
        if (response.status < 400) {
          this.monthTrades = response.data.content;
          this.processTrades();
        }
      });
    },
    processTrades() {
      this.events = [];
      this.tradingDays = {};
      this.tradingDaysData = [
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Number of trades
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Number of positive trades
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Net profit
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Best profit
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Negative Sum
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Positive Sum
      ];

      // Number of trades, Number of positive trades, net profit, best trade
      this.monthTrades.forEach((trade) => {
        if (!(this.formatDate(trade.openTime) in this.tradingDays))
          this.tradingDays[this.formatDate(trade.openTime)] = this.retrieveDay(trade.openTime) - 1;

        this.tradingDaysData[0][this.retrieveDay(trade.openTime) - 1] = this.tradingDaysData[0][this.retrieveDay(trade.openTime) - 1] + 1;
        if (trade.netProfit > 0) {
          this.tradingDaysData[1][this.retrieveDay(trade.openTime) - 1] = this.tradingDaysData[1][this.retrieveDay(trade.openTime) - 1] + 1;
          this.tradingDaysData[5][this.retrieveDay(trade.openTime) - 1] = this.tradingDaysData[5][this.retrieveDay(trade.openTime) - 1] + trade.netProfit;
        } else
          this.tradingDaysData[4][this.retrieveDay(trade.openTime) - 1] = this.tradingDaysData[4][this.retrieveDay(trade.openTime) - 1] + trade.netProfit;

        this.tradingDaysData[2][this.retrieveDay(trade.openTime) - 1] = this.tradingDaysData[2][this.retrieveDay(trade.openTime) - 1] + trade.netProfit;
        this.tradingDaysData[3][this.retrieveDay(trade.openTime) - 1] = Math.max(trade.netProfit, this.tradingDaysData[3][this.retrieveDay(trade.openTime) - 1]);
      });
    },
    getProfitFactor(date) {
      let positiveSum = this.tradingDaysData[5][this.tradingDays[date]];
      let negativeSum = this.tradingDaysData[4][this.tradingDays[date]];
      let profitFactor = negativeSum !== 0 ? Math.abs(positiveSum / negativeSum) : 1;
      return profitFactor.toFixed(2);
    },
    validateShowMore(date) {
      if (this.hoverDate !== null)
        return this.hoverDate === date;
      return false;
    },
    setHoverDay(date) {
      this.hoverDate = date;
    },
    removeHoverDay() {
      this.hoverDate = '';
    },
    retrieveDay(stringDate) {
      let date = new Date(stringDate);
      return date.getDate();
    },
    formatDate(stringDate) {
      let date = new Date(stringDate);
      let month = (date.getMonth() + 1 < 10) ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
      let day = (date.getDate() < 10) ? `0${date.getDate()}` : date.getDate();
      return `${date.getFullYear()}-${month}-${day}`;
    },

  }
}
</script>



<style scoped lang="scss">

.select-account {
  max-width: 40%;
}
@media (max-width: 768px) {
  .container-calendar {
    width: 80%;
  }
}
@media (max-width: 768px) {
  .select-account {
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .summary {
    display: flex;
    flex-direction: column;
  }
}

.arrow {
  color: #929292 !important;
  border: none !important;
  padding: 8px 10px;
  margin: 0 5px;
}


.arrow:hover {
  color: #929292 !important;
  background-color: transparent !important;
  border: none !important;
}

.arrow:focus {
  color: #929292 !important;
  background-color: transparent !important;
  border: none !important;
}

@media (min-width: 600px) {
  .mobile {
    display: none;
  }
}

@media (max-width: 599px) {
  .desktop {
    display: none;
  }
}
</style>
